(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["heyde-polish"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    var sel =
      '.heyde-tm__content,.heyde-tm__media,.heyde-steps__head,.heyde-steps__card,' +
      '.heyde-feat__head,.heyde-feat__item,.heyde-cafe__head,.heyde-cafe__card,' +
      '.heyde-contact__intro,.heyde-contact__formwrap,.heyde-gal__head,.heyde-gal__item,' +
      '.heyde-tl__content';

    var vh = window.innerHeight || 800;
    var toReveal = [];

    [].forEach.call(document.querySelectorAll(sel), function (el) {
      if (el.getBoundingClientRect().top > vh * 0.82) {
        el.classList.add('hk-reveal');
        toReveal.push(el);
      }
    });

    [].forEach.call(
      document.querySelectorAll('.heyde-steps__grid,.heyde-feat__grid,.heyde-gal__grid'),
      function (grid) {
        var i = 0;
        [].forEach.call(grid.children, function (child) {
          if (child.classList.contains('hk-reveal')) {
            child.style.transitionDelay = (i * 0.08).toFixed(2) + 's';
            i++;
          }
        });
      }
    );

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              entry.target.classList.add('hk-in');
              io.unobserve(entry.target);
            }
          });
        },
        { threshold: 0.12, rootMargin: '0px 0px -8% 0px' }
      );
      toReveal.forEach(function (el) {
        io.observe(el);
      });
    } else {
      toReveal.forEach(function (el) {
        el.classList.add('hk-in');
      });
    }
  })();

  (function () {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    [].forEach.call(document.querySelectorAll('[data-hk-slideshow]'), function (box) {
      var slides = box.querySelectorAll('.heyde-tm__slide');
      if (slides.length < 2) return;

      var interval = (parseFloat(box.getAttribute('data-hk-interval')) || 4) * 1000;
      var current = 0;

      setInterval(function () {
        slides[current].classList.remove('is-active');
        current = (current + 1) % slides.length;
        slides[current].classList.add('is-active');
      }, interval);
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
